import React from "react";

export default function PassoResumo({ convidado, onContinuar }) {
  const iniciais = String(convidado?.nome || "?")
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((p) => p[0]?.toUpperCase() || "")
    .join("");

  return (
    <div className="c26-step-panel">
      <p className="c26-lead">
        Revise as informações abaixo e continue para montar sua agenda de
        conteúdos.
      </p>

      <div className="cc-resumo">
        <div className="cc-resumo-avatar" aria-hidden>
          {convidado?.avatar ? (
            <img src={convidado.avatar} alt="" />
          ) : (
            <span>{iniciais || "?"}</span>
          )}
        </div>
        <dl className="cc-resumo-dados">
          <div>
            <dt>Nome</dt>
            <dd>{convidado?.nome || "—"}</dd>
          </div>
          {convidado?.nome_cracha ? (
            <div>
              <dt>Nome no crachá</dt>
              <dd>{convidado.nome_cracha}</dd>
            </div>
          ) : null}
          <div>
            <dt>E-mail</dt>
            <dd>{convidado?.email || "—"}</dd>
          </div>
          <div>
            <dt>Instituição</dt>
            <dd>{convidado?.empresa || "—"}</dd>
          </div>
          <div>
            <dt>Cargo</dt>
            <dd>{convidado?.cargo || "—"}</dd>
          </div>
        </dl>
      </div>

      <div className="c26-actions c26-actions--first-step">
        <button
          type="button"
          className="c26-btn c26-btn-primary"
          onClick={onContinuar}
        >
          Continuar para conteúdos
        </button>
      </div>
    </div>
  );
}
